import { withSearch } from '@elastic/react-search-ui';
import DropDownFacetFilters from '../../../components/filter/DropDownFacetFilter';

const ResearchReportsParishFilter = ({
  facets,
  filters,
  setFilter,
  removeFilter,
}) => {
  return (
    <DropDownFacetFilters
      facets={facets}
      fieldId="parish"
      filters={filters}
      id="parish"
      label="Parish (civil / non-civil)"
      removeFilter={removeFilter}
      setFilter={setFilter}
    />
  );
};

export default withSearch(({ facets, filters, setFilter, removeFilter }) => ({
  facets,
  filters,
  setFilter,
  removeFilter,
}))(ResearchReportsParishFilter);
